// @flow
import React, { Component } from 'react';

import CircularProgress from 'material-ui/CircularProgress';

import ClosableDialog from 'components/ClosableDialog';

import Header from './Header';
import ContactCard from './ContactCard';
import ObtainablesList from './ObtainablesList';
import OverlappingAirspacesList from './OverlappingAirspacesList';
import GeometryTextField from './GeometryTextField';
import BottomNavigation from './BottomNavigation';

const getStyles = ({ isMobile }) => ({
  content: {
    maxWidth: 800,
  },

  body: {
    padding: 0,
    paddingBottom: isMobile ? 128 : 0,
    margin: 0,
    border: '0 none',
    overflow: isMobile ? 'initial' : 'scroll',
    maxHeight: 'auto',
  },

  title: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
  },

  innerContainer: {
    paddingTop: isMobile ? 0 : 112,
    marginBottom: isMobile ? 0 : 72,
  },

  progressContainer: {
    marginTop: 16,
    marginBottom: 16,
    textAlign: 'center',
  },
});

export default class SearchResultsDialog extends Component {
  state = {
    selectedPaneIndex: 0,
    selectedPaneName: null,
  };

  _onPaneSelected(index, name) {
    this.setState({
      selectedPaneIndex: index,
      selectedPaneName: name,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { search } = nextProps;

    // Only switch to the first page if we have new results
    if (
      search &&
      (!this.props.search || search.slug !== this.props.search.slug)
    ) {
      this.setState({
        selectedPaneIndex: 0,
        selectedPaneName: search.has_contact_info
          ? search.availability_result.available === 'AVAILABLE'
            ? 'obtainables'
            : 'overlaps'
          : 'contact',
      });
    }
  }

  renderContents() {
    const { search } = this.props;

    switch (this.state.selectedPaneName) {
      case 'contact':
        return <ContactCard {...this.props} />;
      case 'obtainables':
        return <ObtainablesList {...this.props} />;
      case 'overlaps':
        return <OverlappingAirspacesList {...this.props} />;
      case 'coordinates':
        return <GeometryTextField {...this.props} />;
      default:
        return null;
    }
  }

  render() {
    const {
      browser,
      waiting,
      visible,
      search,
      toggleSearchResultsDialog,
      hasSubscription,
    } = this.props;

    const { selectedPaneIndex } = this.state;
    const isMobile = browser.lessThan.medium;
    const styles = getStyles({ isMobile });

    return (
      <ClosableDialog
        open={visible}
        onRequestClose={() => toggleSearchResultsDialog(false)}
        contentStyle={styles.content}
        bodyStyle={styles.body}
        titleStyle={styles.title}
        modal
        repositionOnUpdate
        autoScrollBodyContent
      >
        {waiting ? null : (
          <Header
            {...this.props}
            onPaneSelected={this._onPaneSelected.bind(this)}
          />
        )}
        <div style={styles.innerContainer}>
          {waiting ? (
            <div style={styles.progressContainer}>
              <CircularProgress size={80} thickness={5} />
            </div>
          ) : (
            this.renderContents()
          )}
        </div>
        {waiting ? null : (
          <BottomNavigation
            browser={browser}
            search={search}
            selectedPaneIndex={selectedPaneIndex}
            hasSubscription={hasSubscription}
            onPaneSelected={this._onPaneSelected.bind(this)}
          />
        )}
      </ClosableDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./components/SearchResultsDialog/SearchResultsDialog.js